import { Stack } from '@mui/material';

const FormWrapper = ({children}) => (
  <Stack direction={'column'} sx={{margin: '0px auto', maxWidth: 550, width: '100%', flexGrow: 1}}>
    {children}
  </Stack>
);

export default FormWrapper;
